import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


import { environment } from 'src/environments/environment';

const baseUrl = environment.envHost + environment.api.apiContext;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class RestService {
  constructor(
    private http: HttpClient,
    public translator: TranslateService) { }

  public _serverError(err: any) {
    if (err instanceof HttpErrorResponse) {
      let error: any = null;
      if (err.status == 404) {
        //return ['Error 404'];
        return throwError(() => err.statusText + " (" + err.status + ")");
      }
      if (err.status == 422) {
        error = err.error;
        if (!error) {
          error = err.statusText;
        } else {
          if (error.constructor === Array) {
            for (const e of error) {
              if (e.indexOf('session.expired') > -1) {
                return throwError(() => 'session.expired');
              }
            }
          }
          // special code to handle a situation when IIS adds the custom error module text
          if (typeof error === 'string' && error.indexOf('The custom error module') > -1) {
            error = error.substring(error.indexOf('['));
          }
        }
      }
    }
    return throwError(() => 'Unknown Error: ' + err.statusText + " (" + err.status + ")");
  }


  public restGet(operationName: string, headers: HttpHeaders, params: HttpParams): Observable<Object> {
    const url = baseUrl + operationName + '/';
    return this.http.get<any>(url, { headers, params }).pipe(map(response => response), catchError(this._serverError));
  }

  public restPost(operationName: string, anyObject: any): Observable<any> {
    const url = baseUrl + operationName + '/';
    const jsonStr = JSON.stringify(anyObject);
    console.log("postUrl:" + url);
    console.log("jsonStr: " + jsonStr);

    return this.http.post(url, jsonStr, httpOptions).pipe(map(response => response), catchError(this._serverError));
  }

}
